import React from 'react'
import { Header } from './TDCss'

function TDHeader() {
  return (
    <Header>
      <div>My TODO Lists</div>
      <div></div>
      <div>EDWIN</div>
    </Header>
  )
}

export default TDHeader